import { Form, Grid, Input } from 'antd';
import React, { useEffect } from 'react';
import { StyledButtonWrapper, StyledButtonLogin, StyledButtonBlueUnbordered } from 'components/styledComponents/button/Button.styled';
import { NavigationService } from 'services';
import { FormInputWrapper } from 'components/styledComponents/input/Input.styled';
import { AppConstants } from 'constants/index';
import { StyledFormMainWrapper } from 'components/styledComponents/form/Form.styled';
import { selectCallEndedStatus } from 'app/settings/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { changeEndedStatus } from 'app/settings/slices';
import { StyledAuthMainWrapper, StyledTitleForm, StyledForgetP } from 'app/auth/components/Login.styled';
import { FormItemErrorMessage } from 'shared/formControl';

interface ForgotProps {
  send: (values: { email: string }) => void;
  title: string;
  text: string;
  isPassword?: boolean;
}

const Forgot = ({
  send, title, text, isPassword,
}: ForgotProps) => {
  const [form] = Form.useForm();
  const { getFieldValue, validateFields } = form;

  const endedStatus = useAppSelector(selectCallEndedStatus);

  const { useBreakpoint } = Grid;

  const screens = useBreakpoint();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    validateFields().then((values) => {
      send(values);
    });
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (endedStatus) {
      dispatch(changeEndedStatus?.(false));
      if (isPassword) {
        const email = getFieldValue('email');
        NavigationService(`/emailSent?email=${email}`);
      } else {
        NavigationService('/login');
      }
    }
  }, [dispatch, endedStatus, getFieldValue, isPassword]);

  return (
    <StyledAuthMainWrapper md={screens.md ? 1 : 0} xs={screens.xs ? 1 : 0}>
      <StyledFormMainWrapper layout="vertical" form={form}>
        <StyledTitleForm>{title}</StyledTitleForm>
        <FormInputWrapper>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: <FormItemErrorMessage errorMassage="Email cannot be empty!" />,
              },
              {
                pattern: new RegExp(AppConstants.regex.email),
                message: <FormItemErrorMessage errorMassage="Wrong email address, please try again!" />,
              },
            ]}
          >
            <Input placeholder="Email" allowClear />
          </Form.Item>
        </FormInputWrapper>
        <StyledForgetP>{text}</StyledForgetP>
        <StyledButtonWrapper>
          <StyledButtonBlueUnbordered
            type="primary"
            onClick={() => {
              NavigationService('/login');
            }}
          >
            Back
          </StyledButtonBlueUnbordered>
          <StyledButtonLogin type="primary" htmlType="submit" onClick={handleSubmit}>
            Send
          </StyledButtonLogin>
        </StyledButtonWrapper>
      </StyledFormMainWrapper>
    </StyledAuthMainWrapper>
  );
};

export default Forgot;
